function calculate_percentage(value1, value2) {

    //Parse numbers
    value1 = parseFloat(value1);
    value2 = parseFloat(value2);

    //Check both values are valid numbers before proceeding
    if(isNaN(value1) || isNaN(value2)) {
        return false;
    }

    //Check value2 is above 0 (no division by 0 please!)
    if(value2 <= 0) {
        return false;
    }

    //Calculate percentage
    var percentage = (value1 / value2) * 100;

    //Return with no decimals
    return percentage.toFixed(0);

}

$(function() {

    //When a quantity is updated, update total
    $body.on('keyup', '.wastage-calculator input:not([name="wastage_amount"])', function(e) {
        var $calc = $(this).closest('.wastage-calculator');

        //Get two quantity values
        var purchase_quantity = $calc.find('input[name="purchase_quantity"]').val();
        var wastage_quantity = $calc.find('input[name="wastage_quantity"]').val();

        //Calculate percentage
        var percentage = calculate_percentage(wastage_quantity, purchase_quantity);

        //Update total
        if(percentage) {
            $calc.find('input[name="wastage_amount"]').val(percentage);
        } else {
            $calc.find('input[name="wastage_amount"]').val('');
        }

        //Set value data for copying
        $calc.data('value', percentage);

    });

    //Copy wastage amount
    $body.on('click', '.copy-wastage-amount', function (e) {
        var $calc = $(this).closest('.wastage-calculator');
        var el = $calc.find('input[name="wastage_amount"]')[0];
        copy_field_value(el);
    });

});
